import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActiveserviceService } from 'src/app/Services/ActiveUsers/activeservice.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IExostars } from 'src/app/models/IExostars';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-epcs-addprovider',
  templateUrl: './epcs-addprovider.component.html',
  styleUrls: ['./epcs-addprovider.component.css']
})
export class EpcsAddproviderComponent implements OnInit {
  addproviderform: FormGroup;

  submitted = false;
  public roles: IExostars[];
  constructor(
    public dialogRef: MatDialogRef<EpcsAddproviderComponent>, private formBuilder: FormBuilder, private toastr: ToastrService,
    private activeserviceService: ActiveserviceService) { }

  ngOnInit() {
    this.addproviderform = this.formBuilder.group({
      ProviderName: ['',],
      npinumber: ['',],
      providerName: ['',],

    });
    this.getAllRoles();
  }

  getAllRoles() {
    this.activeserviceService.getProviders().subscribe(result => {
      this.roles = result;
    });
  }


  onNoClick(): void {
    this.dialogRef.close();
  }
  onSubmit() {
    var results = this.addproviderform.get('providerName').value;
    if (results != "") {
      this.dialogRef.close(results);
    } else {
      this.toastr.warning("Please Select Provider");
      return;
    }

  }

  onCancelClick(): void {
    this.dialogRef.close();
  }


}
